import React from 'react';
import { MessageIcon } from './icons';

const GroupsListView = ({ groups, onSelectGroup, getUnreadCount }) => {
  return (
    <div className="space-y-3">
      {groups.map(group => {
        const memberCount = group.members?.length || 0;
        const inviteCount = group.pendingInviteCount || 0;
        const parts = [];
        if (memberCount > 0) parts.push(`${memberCount} member${memberCount !== 1 ? 's' : ''}`);
        if (inviteCount > 0) parts.push(`${inviteCount} invited`);
        const unread = getUnreadCount ? getUnreadCount(group) : 0;

        return (
          <button
            key={group.id}
            onClick={() => onSelectGroup(group)}
            className="w-full bg-white rounded-2xl p-4 shadow-sm border border-slate-100 active:shadow-md active:border-slate-200 transition-all text-left"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="flex -space-x-2">
                  {group.members.slice(0, 3).map((m) => (
                    <div key={m.id || m.userId} className="w-10 h-10 rounded-full bg-gradient-to-br from-slate-100 to-slate-200 border-2 border-white flex items-center justify-center text-lg">
                      {m.avatar}
                    </div>
                  ))}
                  {group.members.length === 0 && (
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-teal-50 to-teal-100 border-2 border-white flex items-center justify-center">
                      <svg className="w-5 h-5 text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                    </div>
                  )}
                </div>
                <div>
                  <h3 className="font-semibold text-slate-900">{group.name}</h3>
                  <p className="text-xs text-slate-500">
                    {parts.length > 0 ? parts.join(', ') : 'No members yet'}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {unread > 0 ? (
                  <span className="min-w-[22px] h-[22px] bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center px-1.5">
                    {unread > 99 ? '99+' : unread}
                  </span>
                ) : group.messages?.length > 0 ? (
                  <div className="flex items-center gap-1 text-slate-400">
                    <MessageIcon />
                    <span className="text-sm">{group.messages.length}</span>
                  </div>
                ) : null}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default GroupsListView;
